const rail = {
  rails: "Rotaie", // translated
  senior: "Anziano", // translated
  seniors: "Gli anziani", // translated
  youths: "Giovani", // translated
  yearOld: "anni", // translated
  yearsOld: "Anni", // translated
};


export default rail;
